import { ISimulation, ISimulationFine } from 'models/Forms/Simultation';
import api from './config/api';

export const simulateFine = async (data: ISimulation) => api.post('/simulacao_multa/save', data);

export const getSimulation = async (id: number) => api.get<ISimulation>(`/simulacao_multa/${id}`);

export const postSimulationArquived = async (data: FormData) =>
  api.post(`/simulacao_multa/documentos`, data);

export const getListSumulations = async (query?: string) =>
  api.get<ISimulationFine>(`/simulacao_multa/filter${query || ''}`);

export const donwloadSimulationFile = async (idSimulation: string) => {
  return api.get<any>(`/simulacao_multa/download/${idSimulation}`, { responseType: 'arraybuffer' });
};

export interface IReportGen {
  periodoInicial: string;
  periodoFinal: string;
}

export const generateReportSimulatedFines = (data: string) => {
  return api.get(`/simulacao_multa/export-excel${data}`, {
    responseType: 'blob',
  });
};
